import { GEmptyProps } from './types'
import { IoMdAlarm } from 'react-icons/io'

export const GEmpty = ({
	icon: Icon = IoMdAlarm,
	iconClassName = 'h-14 w-14 text-t-base-blue',
	title,
	description,
	action,
	className = ''
}: GEmptyProps) => {
	return (
		<div
			className={`flex flex-col items-center justify-center py-12 ${className}`}
		>
			<Icon className={iconClassName} />
			<strong className="text-t-base-blue my-4 font-medium">{title}</strong>
			{description && (
				<span className="text-t-checkbox-unactive pb-4 max-w-[400px] text-center">
					{description}
				</span>
			)}
			{action && <div className="mt-2">{action}</div>}
		</div>
	)
}

